<template>
    <div class="flex h-full flex-col justify-start overflow-hidden">
        <component
            :is="newsLayout"
            :block="block"
            :article="article"
            :loading="isLoading"
        >
            <template #empty>
                <SystemMessage>
                    <template #title>There is currently no news available.</template>
                </SystemMessage>
            </template>

            <template #loading>
                <GhostArticle />
            </template>
        </component>
    </div>
</template>

<script setup>
    import { newsLayoutQuery, newsLayoutQueryWithId } from '~/queries/sections/news'

    const props = defineProps({
        block: Object,
    })

    const { query } = useGraphQL()
    const newsLayout = defineAsyncComponent(() => import('./layout.async.vue'))

    const article = ref(null)
    const isLoading = ref(true)
    const offset = computed(() => {
        return (props.block?.typeIndex || 1) - 1
    })
    const loadNews = () => {
        isLoading.value = true

        let variables = {
            limit: 1,
            offset: offset.value,
        }

        let queryEntries = newsLayoutQuery

        // Get entry by ID if entry is selected
        if (Array.isArray(props.block?.SelectArticle) && props.block.SelectArticle.length > 0) {
            const selectedId = props.block.SelectArticle[0].id
            variables = {
                id: selectedId,
            }
            queryEntries = newsLayoutQueryWithId
        }

        query({
            query: queryEntries,
            variables,
            server: false,
        }).then((data) => {
            article.value = data?.ds_NewsEntries[0]
            isLoading.value = false
        })
    }

    onMounted(() => {
        nextTick(loadNews)
    })
</script>
